import React, { useEffect, useState } from "react";
import { CustomeStyle } from "../Css/CustomeStyle";
import Footer from "../Fotter";
import { useNavigate } from "react-router-dom";
import fliptwirlsLogo from "../assets/flip.png";
import { useDispatch, useSelector } from "react-redux";
import { CheckoutApi } from "../redux/slices/CheckoutSlice";
import { viewCartData } from "../redux/slices/ViewCartSlice";
import CryptoJS from "crypto-js";
import LoaderPage from "./Loader";
import axios from "axios";
import endPoint from "../redux/EndPoint/endpoint";
import { toast } from "react-toastify";
import QRCode from "react-qr-code";
import { io } from "socket.io-client";
import NeoPaymentModal from "./NeoPaymentModal";

const Checkout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ViewCart } = useSelector((state) => state.viewCart);
  const [selectedPayment, setSelectedPayment] = useState('Online');
  const [loading, setLoading] = useState(false);
  const [showModal, setModal] = useState(false);
  const [selectedGateway, setSelectedGateway] = useState(null);
  const [isOrderConfirmed, setIsOrderConfirmed] = useState(false);
  const [showExitPopup, setShowExitPopup] = useState(false);
  const navigateRef = React.useRef(null);
  const [guestDetails, setGuestDetails] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    country: "India",
    streetAddress: "",
    houseNumber: "",
    apartment: "",
    city: "",
    state: "Madhya Pradesh",
    pinCode: "",
    phone: "",
    email: "",
    shippingAddress: false,
    orderNotes: "",
  });
  const [ispayamentMode, setPaymentMode] = useState([])
  const [showUPIModal, setShowUPIModal] = useState(false);
  const [upiPaymentData, setUpiPaymentData] = useState(null);
  const [upiTimer, setUpiTimer] = useState(180);
  const [isVerifyingPayment, setIsVerifyingPayment] = useState(false);
  const [upiStatusText, setUpiStatusText] = useState("");
  const [showNeoModal, setShowNeoModal] = useState(false);
  const [neoPaymentData, setNeoPaymentData] = useState(null);

  const formatTimer = (seconds) => {
    const safeSecs = Math.max(0, Number(seconds) || 0);
    const mins = Math.floor(safeSecs / 60);
    const secs = safeSecs % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  useEffect(() => {
    dispatch(viewCartData());
  }, [dispatch]);

  const generateSignatureFrontend = (paymentPayload, secretKey) => {
    const sortedValues = Object.entries(paymentPayload)
      .filter(([key, value]) => {
        if (key === "subMerchantPayInfo") return true;
        return value !== null && value !== undefined;
      })
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
      .map(([key, value]) => {
        if (
          key === "subMerchantPayInfo" &&
          (value === null || value === undefined)
        ) {
          return "null";
        }
        return value;
      })
      .join("");

    const stringToHash = sortedValues + secretKey;
    const hash = CryptoJS.SHA256(stringToHash);
    return hash.toString(CryptoJS.enc.Hex);
  };

  const submitToFreecharge = (url, payload) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;

    Object.keys(payload).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = payload[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  const handleCheckout = async () => {
    if (
      !guestDetails.firstName ||
      !guestDetails.lastName ||
      !guestDetails.streetAddress ||
      !guestDetails.city ||
      !guestDetails.state ||
      !guestDetails.pinCode ||
      !guestDetails.phone ||
      !guestDetails.email
    ) {
      alert("Error: Please fill in all required fields.");
      return;
    } else if (selectedPayment == null) {
      alert("Error: Please Select Payment Method");
    } else {
      setLoading(true);
      const billingAddress = {
        firstName: guestDetails?.firstName,
        lastName: guestDetails?.lastName,
        email: guestDetails?.email,
        streetAddress: guestDetails?.streetAddress,
        city: guestDetails?.city,
        state: guestDetails?.state,
        pinCode: guestDetails?.pinCode,
        phone: guestDetails?.phone,
        paymentMethod: selectedPayment,
      };
      dispatch(CheckoutApi(billingAddress))
        .then((response) => {
          if (response?.meta?.requestStatus === "rejected") {
            console.error("Orddfsdfdser failed:", response?.payload);
            toast.info(response?.payload || "Failed")
            return;
          }

          const data = response?.payload;

          if (
            response?.meta?.requestStatus === "fulfilled" &&
            data &&
            data?.success !== false &&
            data?.status !== "FAILED"
          ) {
            navigate("/OrderPlace", {
              state: { data: response },
            });
          } else {
            console.log("response?.message", response)
            toast.info(response?.message)
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error placing order:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // const _handleDhanKubera = async () => {
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   // -----------------*************--------------ONline Payment with FreeCharge Gateway (Disabled) ---------------*************--------
  //   setLoading(true);
  //   if (
  //     !guestDetails.firstName ||
  //     !guestDetails.lastName ||
  //     !guestDetails.streetAddress ||
  //     !guestDetails.city ||
  //     !guestDetails.state ||
  //     !guestDetails.pinCode ||
  //     !guestDetails.phone ||
  //     !guestDetails.email
  //   ) {
  //     alert("Error: Please fill in all required fields.");
  //     return;
  //   } else if (selectedPayment == null) {
  //     alert("Error: Please Select Payment Method");
  //   } else if (
  //     !emailRegex.test(guestDetails.email)
  //   ) {
  //     toast.error("Please enter a valid email address");
  //     return;
  //   }
  //   else {
  //     setLoading(true);
  //     const billingAddress = {
  //       firstName: guestDetails?.firstName,
  //       lastName: guestDetails?.lastName,
  //       email: guestDetails?.email,
  //       streetAddress: guestDetails?.streetAddress,
  //       city: guestDetails?.city,
  //       state: guestDetails?.state,
  //       pinCode: guestDetails?.pinCode,
  //       phone: guestDetails?.phone,
  //       paymentMethod: selectedPayment,
  //     };

  //     const response = await dispatch(CheckoutApi(billingAddress));
  //     const orderId = response?.payload?.orderId;

  //     if (!orderId) {
  //       alert("Order ID not generated Please try again");
  //       setLoading(false)
  //       return;
  //     }

  //     const merchantTransactionId =
  //       orderId;

  //     if (!merchantTransactionId) {
  //       toast.error("Transaction ID not generated");
  //       return;
  //     }

  //     // -----------------------------------------DhanKubera Gateway Integration ----------------------------------------

  //     const BROWSER_VERIFY_URL =
  //       "https://merchant.dhankubera.com/payin/callback";

  //     const dhanKubera = {
  //       token: "$2y$10$rvNqEOPaK01f4dYUJClld.IO1a5vpZWQ/1gzZ7Aa4xp6Yz1X228kG",
  //       userid: "GWSDK1243",
  //       amount: ViewCart?.finalPrice,
  //       mobile: guestDetails?.phone,
  //       name: guestDetails?.name,
  //       orderid: orderId,
  //       callback_url: `${BROWSER_VERIFY_URL}?txnId=${merchantTransactionId}`,
  //     };

  //     console.log("💳 UrbanPay Payload:", dhanKubera);

  //     const pgRes = await axios.post(
  //       "https://merchant.dhankubera.com/api/pg/urbanpay/initiate",
  //       dhanKubera,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //         },
  //       }
  //     );

  //     const pgData = pgRes.data;
  //     if (pgData?.status && pgData?.url) {
  //       window.location.href = pgData.url;
  //       return;
  //     }
  //     if (pgData?.status && pgData?.checkout_url && pgData?.payload) {
  //       submitToFreecharge(pgData.checkout_url, pgData.payload);
  //       return;
  //     }
  //     toast.error("Payment gateway error");
  //   }
  // };


  const _handleDhanKubera = async () => {

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setLoading(true);

    if (
      !guestDetails.firstName ||
      !guestDetails.lastName ||
      !guestDetails.streetAddress ||
      !guestDetails.city ||
      !guestDetails.state ||
      !guestDetails.pinCode ||
      !guestDetails.phone ||
      !guestDetails.email

    ) {

      alert("Error: Please fill in all required fields.");
      setLoading(false);
      return;
    } else if (selectedPayment == null) {
      alert("Error: Please Select Payment Method");
      setLoading(false);
      return;
    } else if (!emailRegex.test(guestDetails.email)) {
      toast.error("Please enter a valid email address");
      setLoading(false);
      return;

    }

    try {
      const billingAddress = {
        firstName: guestDetails?.firstName,
        lastName: guestDetails?.lastName,
        email: guestDetails?.email,
        streetAddress: guestDetails?.streetAddress,
        city: guestDetails?.city,
        state: guestDetails?.state,
        pinCode: guestDetails?.pinCode,
        phone: guestDetails?.phone,
        paymentMethod: selectedPayment,
        gatewaySelector: "Dhankubera"
      };

      const response = await dispatch(CheckoutApi(billingAddress));

      const pgData = response?.payload;
      if (!pgData || !pgData.orderId) {
        alert("Order ID not generated. Please try again.");
        setLoading(false);
        return;
      }

      if (pgData?.paymentMode === "PayU" && pgData?.payuData) {
        redirectToPayU(pgData.payuData);
        return;
      }

      if (pgData.paymentMode === "REDIRECT" && pgData.paymentUrl) {
        console.log("🚀 Redirecting to Payment Gateway...");
        window.location.href = pgData.paymentUrl;
        return;
      }

      // CASE B: Direct Form Submission (Used by Freecharge)

      if (pgData.paymentMode === "POST_FORM" && pgData.checkoutUrl) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = pgData.checkoutUrl;

        Object.keys(pgData.payload).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = pgData.payload[key];
          form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit(); // Sends user to the secure Freecharge page
        return;
      }

      // Fallback if no specific instruction matched

      console.error("❌ Invalid PG response structure", pgData);
      toast.error(pgData.message || "Payment gateway error");
    } catch (error) {
      console.error("❌ ERROR IN PAYMENT FLOW:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  // --------------------------------------freecharge Gateway Integration ----------------------------------------
  // const FREECHARGE_MERCHANT_ID = "MER82620b8df7";
  // const FREECHARGE_CALLBACK_URL = `https://www.fliptwirls.com/users/verify-payment?orderId=${orderId}`;

  // const timestamp = Math.floor(Date.now() / 1000);
  // const merchantTxnId = orderId;
  // const merchantTxnAmount = (ViewCart?.finalPrice || 0).toFixed(1)
  // const paymentPayload = {
  //   merchantId: FREECHARGE_MERCHANT_ID,
  //   currency: "INR",
  //   callbackUrl: FREECHARGE_CALLBACK_URL,
  //   timestamp: timestamp,
  //   merchantTxnAmount: merchantTxnAmount,
  //   merchantTxnId: merchantTxnId,
  // };

  // const signature = generateSignatureFrontend(
  //   paymentPayload,
  //   "aFor7b+PvWJdFU09wGOODg6dj6h5A7vHsZF8bsVHzXY="
  // );

  // paymentPayload.signature = signature;
  // const checkoutUrl =
  //   "https://secure-axispg.freecharge.in/payment/v1/checkout";
  // const form = document.createElement("form");
  // form.method = "POST";
  // form.action = checkoutUrl;
  // form.style.display = "none";
  // form.id = "frmPay";

  // for (const key in paymentPayload) {
  //   const element = document.createElement("input");
  //   element.value = paymentPayload[key];
  //   element.name = key;
  //   form.appendChild(element);
  // }

  // document.body.appendChild(form);
  // form.submit();
  // setTimeout(() => {
  //   setLoading(false);
  // }, 5000)

  useEffect(() => {
    const isCODAvailable = ViewCart?.cart?.every(item => item.isCodeAvailable);
    if (!isCODAvailable) {
      setSelectedPayment("Online");

    }
  }, [ViewCart]);

  const handleCloseModal = () => setModal(false);

  const handleRemoveGift = async () => {
    const storedUuid = localStorage.getItem("uuid");
    setLoading(true);
    try {
      const response = await axios.delete(`${endPoint.REMOVEFREEGIFT}`, {
        data: { sessionId: storedUuid },
      });
      setModal(false);
      dispatch(viewCartData());
    } catch (error) {
      console.error("Error removing gift:", error);
      // alert("Failed to remove gift. Please try again.");
      toast.error("Failed to remove gift. Please try again!", {
        position: "top-center",
        autoClose: 2000,
        style: {
          background: "#d0d3d4",
          color: "black",
          fontWeight: "bold",
        },
      });
    } finally {
      setModal(false);
      setLoading(false);
    }
  };

  const handleGift = () => {
    setLoading(true);
    const storedUuid = localStorage.getItem("uuid");
    axios.post(`${endPoint.ADDONLINEFREEGIFT}`, {
      sessionId: storedUuid,
    })
      .then((res) => {
        setModal(false);
        dispatch(viewCartData());
      })
      .catch((error) => {
        setModal(false);
        // toast.error("Failed to add gift. Please try again!", {
        //   position: "top-center",
        //   autoClose: 2000,
        //   style: {
        //     background: "#d0d3d4",
        //     color: "black",
        //     fontWeight: "bold",
        //   },
        // });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   window.history.pushState({ page: "checkout" }, "", window.location.href);

  //   const handlePopState = (event) => {
  //     if (!isOrderConfirmed) {
  //       event.preventDefault();
  //       setShowExitPopup(true);
  //       window.history.pushState(
  //         { page: "checkout" },
  //         "",
  //         window.location.href
  //       );
  //     }
  //   };

  //   window.addEventListener("popstate", handlePopState);
  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, [isOrderConfirmed]);

  useEffect(() => {
    if (ViewCart?.cart && ViewCart.cart.length > 0) {
      fetchMethodPayment();
    }
  }, [ViewCart?.cart]);

  const fetchMethodPayment = async () => {
    try {
      const response = await axios.post(endPoint.PaymentMethid, {
        cartItems: ViewCart?.cart || ViewCart?.items || [],
      });

      const data = response?.data?.data;

      const allowedMethods = data?.allowedPaymentMethods || [];
      const globalSettings = data?.globalSettings || {};

      const isCodAvailable =
        allowedMethods.includes("COD") &&
        globalSettings.isCodGlobalEnabled === true;

      const isOnlineAvailable =
        allowedMethods.includes("Online") &&
        globalSettings.isOnlineEnabled === true;

      setPaymentMode([
        ...(isOnlineAvailable ? ["Online"] : []),
        ...(isCodAvailable ? ["COD"] : []),
      ]);
    } catch (err) {
      console.error("Payment methods fetch error:", err);
      setPaymentMode([]);
    }
  };


  const redirectToPayU = (payuData) => {
    if (!payuData || !payuData.action) {
      console.error("Invalid PayU data:", payuData);
      toast.error("Invalid PayU payment configuration.");
      return;
    }

    // 1. Ek hidden HTML form create karo
    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", payuData.action); // PayU Payment URL

    // 2. Saare payuData fields ko hidden inputs bana kar form me dalo
    for (const key in payuData) {
      if (key !== "action" && payuData[key] !== undefined && payuData[key] !== null) {
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", key);
        input.setAttribute("value", payuData[key]);
        form.appendChild(input);
      }
    }

    // 3. Form ko body me daal kar auto-submit kar do
    document.body.appendChild(form);
    form.submit();
  };

  const _handleUPIAadiPay = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      !guestDetails.firstName?.trim() ||
      !guestDetails.lastName?.trim() ||
      !guestDetails.streetAddress?.trim() ||
      !guestDetails.city?.trim() ||
      !guestDetails.state?.trim() ||
      !guestDetails.pinCode?.trim() ||
      !guestDetails.phone?.trim() ||
      !guestDetails.email?.trim()
    ) {
      toast.error("Please fill in all required billing fields.");
      return;
    }

    if (!emailRegex.test(guestDetails.email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);
      const billingAddress = {
        firstName: guestDetails?.firstName,
        lastName: guestDetails?.lastName,
        email: guestDetails?.email,
        streetAddress: guestDetails?.streetAddress,
        city: guestDetails?.city,
        state: guestDetails?.state,
        pinCode: guestDetails?.pinCode,
        phone: guestDetails?.phone,
        paymentMethod: selectedPayment,
      };
      const storedUuid = localStorage.getItem("uuid");
      // 6. Direct API call (no Redux)
      const response = await axios.post(
        endPoint.PLACEORDER,
        {
          paymentMethod: "Online",
          billingAddress,
          sessionId: storedUuid || "",
          gatewaySelector: "AadiPay",
        },
        {
          headers: {
            "Content-Type": "application/json",
            sessionId: storedUuid || "",
          },
        }
      );

      const pgData = response.data;
      console.log("[AadiPay] API response:", pgData);

      if (pgData?.paymentMode === "PayU" && pgData?.payuData) {
        redirectToPayU(pgData.payuData);
        return;
      }

      // Extract UPI string/link from AadiPay (upiString) or other gateway response
      const upiUrl =
        pgData?.upiString ||
        pgData?.upilink ||
        pgData?.qrString ||
        pgData?.gatewayResponse?.data?.qrString ||
        pgData?.gatewayResponse?.data?.upilink;

      if (upiUrl) {
        setUpiPaymentData({
          qrString: upiUrl,
          upilink: upiUrl,
          orderId: pgData?.orderId || pgData?.referenceId,
          amount:
            pgData?.amount ??
            pgData?.totalPrice ??
            ViewCart?.finalPrice ??
            0,
          txnId: pgData?.transactionId || pgData?.txn_id || "",
          paymentUrl: pgData?.paymentUrl,
        });

        setUpiTimer(180);
        setIsVerifyingPayment(false);
        setUpiStatusText("");
        setShowUPIModal(true);
        return;
      }

      if (pgData?.paymentMode === "REDIRECT" && pgData?.paymentUrl) {
        window.location.href = pgData.paymentUrl;
        return;
      }

      toast.error(
        pgData?.message ||
        "AadiPay payment could not be initiated."
      );
    } catch (error) {
      console.error(
        "[AadiPay] Checkout error:",
        error.response?.data || error.message || error
      );

      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Payment initiation failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };


  const handleManualStatusCheck = async () => {
    if (!upiPaymentData?.orderId || isVerifyingPayment) return;
    const orderId = String(upiPaymentData.orderId);
    try {
      setIsVerifyingPayment(true);
      setUpiStatusText("Checking payment status with bank...");
      const res = await fetch(
        `${endPoint.PaymentStatus}/${encodeURIComponent(orderId)}/payment-status`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const result = await res.json();
      const status = (
        result?.paymentStatus ||
        result?.data?.paymentStatus ||
        result?.status ||
        result?.data?.status ||
        ""
      ).toUpperCase();

      if (status === "SUCCESS" || status === "PAID" || status === "COMPLETED") {
        setShowUPIModal(false);
        setUpiPaymentData(null);
        toast.success("Payment successful!");
        navigate(`/paymentResultPage?status=SUCCESS&orderId=${encodeURIComponent(orderId)}`);
      } else if (status === "PENDING") {
        setShowUPIModal(false);
        setUpiPaymentData(null);
        toast.info("Payment is pending.");
        navigate(`/paymentResultPage?status=PENDING&orderId=${encodeURIComponent(orderId)}`);
      } else if (status === "FAILED" || status === "FAILURE") {
        setShowUPIModal(false);
        setUpiPaymentData(null);
        toast.error("Payment failed.");
        navigate(`/paymentResultPage?status=FAILED&orderId=${encodeURIComponent(orderId)}`);
      } else {
        toast.info("Payment not detected yet. Please ensure you completed it in your UPI app.");
      }
    } catch (err) {
      console.error("Manual status check error:", err);
      toast.error("Unable to check status right now. Please wait.");
    } finally {
      setIsVerifyingPayment(false);
      setUpiStatusText("");
    }
  };

  const handleCancelUPI = () => {
    if (window.confirm("Are you sure you want to cancel this payment?")) {
      setShowUPIModal(false);
      setUpiPaymentData(null);
      setIsVerifyingPayment(false);
      setUpiStatusText("");
      toast.info("Payment cancelled.");
    }
  };

  useEffect(() => {
    if (!showUPIModal || !upiPaymentData?.orderId) return;

    const orderId = String(upiPaymentData.orderId);
    let isActive = true;
    let redirected = false;
    let oneMinuteChecked = false;

    // Connect pure WebSocket directly to backend
    const socketBaseUrl = endPoint.SOCKET_URL || "https://www.fliptwirls.com";
    const socket = io(socketBaseUrl, {
      transports: ["websocket"],
      upgrade: false,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
    });

    const handlePaymentResult = (status) => {
      if (!isActive || redirected) return;
      redirected = true;
      socket.disconnect();
      setShowUPIModal(false);
      setUpiPaymentData(null);

      const upperStatus = (status || "").toUpperCase();
      if (upperStatus === "SUCCESS" || upperStatus === "PAID" || upperStatus === "COMPLETED") {
        toast.success("Payment successful!");
        navigate(`/paymentResultPage?status=SUCCESS&orderId=${encodeURIComponent(orderId)}`);
      } else if (upperStatus === "PENDING") {
        toast.info("Payment is pending.");
        navigate(`/paymentResultPage?status=PENDING&orderId=${encodeURIComponent(orderId)}`);
      } else if (upperStatus === "FAILED" || upperStatus === "FAILURE") {
        toast.error("Payment failed.");
        navigate(`/paymentResultPage?status=FAILED&orderId=${encodeURIComponent(orderId)}`);
      }
    };

    const handlePaymentUpdate = (data) => {
      if (!isActive || redirected) return;

      const incomingOrderId =
        data?.orderId ||
        data?.data?.orderId ||
        data?.data?.order_id ||
        data?.order_id;

      if (incomingOrderId && String(incomingOrderId) !== orderId) {
        return;
      }

      const status = (
        data?.paymentStatus ||
        data?.data?.paymentStatus ||
        data?.status ||
        data?.data?.status ||
        ""
      ).toUpperCase();

      console.log("[SOCKET] Status received:", status, data);
      if (status === "SUCCESS" || status === "FAILED" || status === "PENDING") {
        handlePaymentResult(status);
      }
    };

    const checkPaymentStatus = async () => {
      if (!isActive || redirected) return;
      try {
        setIsVerifyingPayment(true);
        setUpiStatusText("1 minute elapsed. Verifying payment status with bank...");

        const res = await fetch(
          `${endPoint.PaymentStatus}/${encodeURIComponent(orderId)}/payment-status`
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const result = await res.json();
        console.log("[1-MIN API CHECK] Status result:", result);

        const status = (
          result?.paymentStatus ||
          result?.data?.paymentStatus ||
          result?.status ||
          result?.data?.status ||
          ""
        ).toUpperCase();

        if (status === "SUCCESS" || status === "FAILED" || status === "PENDING") {
          handlePaymentResult(status);
          return;
        }
      } catch (err) {
        console.warn("[PAYMENT] 1-min check failed:", err);
      } finally {
        if (isActive && !redirected) {
          setIsVerifyingPayment(false);
          setUpiStatusText("");
        }
      }
    };

    socket.on("connect", () => {
      if (!isActive) return;
      console.log("[SOCKET] Connected successfully:", socket.id);
      socket.emit("watch-order", { orderId });
    });

    socket.on("payment-status-updated", handlePaymentUpdate);

    socket.on("connect_error", (err) => {
      console.error("[SOCKET] Connection error:", err.message);
    });

    socket.on("payment-watch-error", (err) => {
      console.error("[SOCKET] Watch error:", err.message);
    });

    // Countdown interval (180s down to 0s)
    let currentSeconds = 180;
    setUpiTimer(180);

    const timerInterval = setInterval(() => {
      if (!isActive || redirected) return;

      currentSeconds -= 1;
      setUpiTimer(currentSeconds);

      // When 1 minute has passed (currentSeconds === 120, i.e. 60s elapsed)
      if (currentSeconds === 120 && !oneMinuteChecked) {
        oneMinuteChecked = true;
        console.log("⏱️ 1 minute elapsed. Calling payment status API...");
        checkPaymentStatus();
      }

      // If timer expires after 3 minutes (00:00) and no payment completed:
      if (currentSeconds <= 0) {
        clearInterval(timerInterval);
        if (!redirected) {
          redirected = true;
          socket.disconnect();
          setShowUPIModal(false);
          setUpiPaymentData(null);
          toast.warning("Payment session expired (3 mins). Redirecting to home...");
          navigate("/");
        }
      }
    }, 1000);

    return () => {
      isActive = false;
      clearInterval(timerInterval);
      socket.disconnect();
    };
  }, [showUPIModal, upiPaymentData?.orderId, navigate]);

  const _handleNeoPayment = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // 1. Validate required billing details
    if (
      !guestDetails.firstName?.trim() ||
      !guestDetails.lastName?.trim() ||
      !guestDetails.streetAddress?.trim() ||
      !guestDetails.city?.trim() ||
      !guestDetails.state?.trim() ||
      !guestDetails.pinCode?.trim() ||
      !guestDetails.phone?.trim() ||
      !guestDetails.email?.trim()
    ) {
      toast.info("Please fill in all required fields.");
      return;
    }

    // 2. Validate email
    if (!emailRegex.test(guestDetails.email.trim())) {
      toast.info("Please enter a valid email address.");
      return;
    }

    // 3. Validate phone
    const phone = guestDetails.phone.replace(/\D/g, "");

    if (phone.length < 10 || phone.length > 15) {
      toast.info("Please enter a valid phone number.");
      return;
    }

    // 4. Validate payment method
    if (selectedPayment !== "Online") {
      toast.info("Please select Online payment.");
      return;
    }

    if (selectedGateway !== "NeoPayments") {
      toast.info("Please select NeoPayments.");
      return;
    }

    // 5. Prepare billing address
    const billingAddress = {
      firstName: guestDetails.firstName.trim(),
      lastName: guestDetails.lastName.trim(),
      email: guestDetails.email.trim(),
      streetAddress: guestDetails.streetAddress.trim(),
      city: guestDetails.city.trim(),
      state: guestDetails.state.trim(),
      pinCode: guestDetails.pinCode.trim(),
      phone,
    };

    const username = process.env.REACT_APP_NEOPAYMENTS_USERNAME || 'Swadeep';
    const password = process.env.REACT_APP_NEOPAYMENTS_PASSWORD || "Swadeep$%2026";

    if (!username || !password) {
      throw new Error("NeoPayments credentials are missing");
    }

    const loginBody = new URLSearchParams({
      username,
      password,
    }).toString();

    try {
      setLoading(true);

      const loginResponse = await axios.post(
        process.env.REACT_APP_NEOPAYMENTS_LOGIN_URL ||
        process.env.NEOPAYMENTS_LOGIN_URL ||
        "https://api.neopayment.in/api/v1/auth/login",
        loginBody,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          timeout: 20000,
        }
      );

      const accessToken = loginResponse.data?.access_token;

      if (!accessToken) {
        throw new Error("NeoPayments authentication failed");
      }

      const storedUuid = localStorage.getItem("uuid");
      // 6. Direct API call (no Redux)
      const response = await axios.post(
        endPoint.PLACEORDER,
        {
          paymentMethod: "Online",
          billingAddress,
          sessionId: storedUuid || "",
          gatewaySelector: "NeoPayments",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
            sessionId: storedUuid || "",
          },
        }
      );

      const pgData = response.data;

      console.log("[NeoPayments] API response:", pgData);

      // 7. Handle REDIRECT mode (http / https url)
      if (
        pgData?.paymentMode === "REDIRECT" &&
        pgData?.paymentUrl &&
        (pgData.paymentUrl.startsWith("http://") || pgData.paymentUrl.startsWith("https://"))
      ) {
        console.log("[NeoPayments] Redirecting to payment page...");
        window.location.assign(pgData.paymentUrl);
        return;
      }

      // 8. Handle UPI mode (QR & Intent URL)
      if (
        pgData?.paymentMode === "UPI" ||
        pgData?.paymentUrl?.startsWith("upi://") ||
        pgData?.intentUrl?.startsWith("upi://") ||
        pgData?.qrImageUrl
      ) {
        console.log("[NeoPayments] Opening UPI QR modal...");
        const upiString = pgData?.intentUrl || pgData?.paymentUrl || "";
        const matchAmount = upiString.match(/[?&]am=([0-9.]+)/i);
        const orderAmount = matchAmount
          ? matchAmount[1]
          : (ViewCart?.finalPrice ? ViewCart.finalPrice.toFixed(2) : "0.00");

        setNeoPaymentData({
          orderId: pgData?.orderId || "",
          paymentUrl: pgData?.paymentUrl || "",
          intentUrl: pgData?.intentUrl || "",
          qrImageUrl: pgData?.qrImageUrl || null,
          amount: orderAmount,
          message: pgData?.message || "NeoPayments payment initiated",
          paymentGateway: pgData?.paymentGateway || "NeoPayments",
        });
        setShowNeoModal(true);
        return;
      }

      // 9. Handle unexpected response
      console.error(
        "[NeoPayments] Payment URL / UPI details missing:",
        pgData
      );

      toast.error(
        pgData?.message ||
        "NeoPayments payment could not be initiated."
      );
    } catch (error) {
      console.error(
        "[NeoPayments] Checkout error:",
        error.response?.data || error.message || error
      );

      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Payment initiation failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="flex justify-center mb-[-20px]">
        <img loading="lazy" src={fliptwirlsLogo} alt="fliptwirls Logo" className="h-32" />
      </div>
      <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
        Checkout
      </h1>
      <div className="flex flex-col md:flex-row min-h-screen w-full sm:w-[95%] md:w-[95%] mx-auto p-4 rounded-lg bg-gray-50">
        <div className="h-[20%] w-full md:w-[50%] bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl font-semibold mb-5 text-gray-700">
            Billing Information
          </h2>
          <div className="flex flex-col gap-1">
            <div className="flex gap-5">
              <input
                type="text"
                placeholder="First Name *"
                value={guestDetails.firstName}
                onChange={(e) =>
                  setGuestDetails({
                    ...guestDetails,
                    firstName: e.target.value,
                  })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%] `}
              />
              <input
                type="text"
                placeholder="Last Name *"
                value={guestDetails.lastName}
                onChange={(e) =>
                  setGuestDetails({ ...guestDetails, lastName: e.target.value })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%]`}
              />
            </div>
            <select
              value={guestDetails.country}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, country: e.target.value })
              }
              className={CustomeStyle.inputBox}
            >
              <option value="India">India</option>
            </select>
            <input
              type="text"
              placeholder="Full Address - House no. , Bulding"
              value={guestDetails.streetAddress}
              onChange={(e) =>
                setGuestDetails({
                  ...guestDetails,
                  streetAddress: e.target.value,
                })
              }
              className={CustomeStyle.inputBox}
            />
            <div className="flex gap-5">
              <input
                type="text"
                placeholder="City *"
                value={guestDetails.city}
                onChange={(e) =>
                  setGuestDetails({ ...guestDetails, city: e.target.value })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%]`}
              />
              <input
                type="text"
                placeholder="State *"
                value={guestDetails.state}
                onChange={(e) =>
                  setGuestDetails({ ...guestDetails, state: e.target.value })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%]`}
              />
            </div>
            <input
              type="number"
              placeholder="PIN Code *"
              value={guestDetails.pinCode}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, pinCode: e.target.value })
              }
              className={CustomeStyle.inputBox}
            />
            <input
              type="tel"
              placeholder="Phone *"
              value={guestDetails.phone}
              onChange={(e) =>
                setGuestDetails({
                  ...guestDetails,
                  phone: e.target.value.replace(/[^0-9]/g, ""),
                })
              }
              className={CustomeStyle.inputBox}
            />
            <input
              type="email"
              placeholder="Email Address *"
              value={guestDetails.email}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, email: e.target.value })
              }
              className={CustomeStyle.inputBox}
            />
          </div>

          <div className="mt-6">
            <label className="text-lg text-gray-600 mb-5 block">
              <input
                type="checkbox"
                checked={guestDetails.shippingAddress}
                onChange={(e) =>
                  setGuestDetails({
                    ...guestDetails,
                    shippingAddress: e.target.checked,
                  })
                }
                className="mr-2"
              />
              Ship to a different address?
            </label>
            <textarea
              placeholder="Order Notes (Optional)"
              value={guestDetails.orderNotes}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, orderNotes: e.target.value })
              }
              className="block w-full p-3 mb-6 text-lg border border-gray-300 rounded-lg bg-gray-50 h-32"
            />
          </div>
        </div>

        <div className="h-full w-[100%] md:w-[50%] bg-white p-5 rounded-lg shadow-sm mt-6 md:mt-0 ml-0 md:ml-8">
          <h2 className="text-2xl font-semibold mb-5">Your Order</h2>

          {ViewCart?.cart &&
            Array.isArray(ViewCart.cart) &&
            ViewCart.cart.length > 0 ? (
            <>
              {/* Table Header */}
              <div className="flex justify-between  pb-2 mb-1 text-gray-500 font-medium">
                <span className="w-[45%]">Item</span>
                <span>Sale Price</span>
                <span>Qty</span>
                <span>Price</span>
              </div>

              {/* Table Rows */}
              {ViewCart.cart.map((item, index) => {
                return (
                  <div key={index} className="mb-4">
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700 w-[50%] overflow-hidden line-clamp-3">
                        {item.title}
                      </span>
                      <span className="text-gray-600">{item.salePrice}</span>
                      <span className="text-gray-600">{item.quantity}</span>
                      <span className="font-semibold text-blue-500">
                        ₹{item.finalPrice}
                      </span>
                    </div>
                    {item?.appliedCoupon && (
                      <div className="rounded-lg  border-b  mb-5 pb-5 ">
                        <span className="text-black  text-xs font-semibold">
                          Apply Coupons:
                        </span>
                        <div className=" text-gray-600">
                          <span className="text-xs font-semibold text-black">
                            Discount:{" "}
                          </span>
                          <span className=" text-xs text-black font-semibold ms-2">
                            {item?.appliedCoupon?.discountType == "fixed" &&
                              "₹"}
                            {item?.appliedCoupon?.discountValue}{" "}
                            {item?.appliedCoupon?.discountType == "fixed"
                              ? ""
                              : "%"}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-semibold text-black">
                            Discount Price:
                          </span>
                          <span className="text-xs font-semibold text-black">
                            ₹{item?.finalPrice}
                          </span>
                          <span className="text-xs line-through text-gray-500">
                            ₹{item?.totalBeforeCoupon}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </>
          ) : (
            <p>No items in the cart.</p>
          )}

          {/* ---------------------------------Order Data -------------------------------- */}

          <div className="flex justify-between font-semibold mt-1 text-gray-600">
            <span>Shipping Charges</span>
            <span className="text-black font-semibold">
              ₹ {ViewCart?.shippingCost}
            </span>
          </div>
          <div className="flex justify-between font-semibold text-xl  border-gray-200">
            <span>Total</span>
            <span>₹{ViewCart?.finalPrice?.toFixed(2)}</span>
          </div>

          <div className="mx-auto p-6 bg-white shadow-lg rounded-lg border mt-4 border-gray-100">
            <div className="mb-6">
              <h3 className="font-semibold text-lg mb-2">Pay Securely</h3>
            </div>

            {/* ================================Online ------------------------------------------------- */}
            {ispayamentMode?.includes("Online") &&
              <section className="mt-4">
                <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                  <label
                    className="flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer"
                    onClick={() => {
                      setIsOrderConfirmed(true);
                      setSelectedPayment("Online");
                      setSelectedGateway("DhanKubera");
                      handleGift();
                    }}
                  >
                    <input
                      type="radio"
                      name="payment"
                      className="w-4 h-4 text-green-600 focus:ring-green-500"
                      checked={selectedPayment === "Online" && selectedGateway === "DhanKubera"}
                      readOnly
                    />
                    <span className="text-lg text-gray-700">
                      Pay with DhanKubera Credit Card / Debit Card / UPI / Internet Banking
                    </span>
                  </label>
                </div>
              </section>
            }


            {/* {ispayamentMode?.includes("Online") && ( */}
            {/* ================================Adi Pay ------------------------------------------------- */}

            <section className="mt-4">
              <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                <label
                  className="flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer"
                  onClick={() => {
                    setSelectedPayment("Online");
                    setSelectedGateway("AadiPay");
                  }}
                >
                  <input
                    type="radio"
                    name="payment"
                    className="w-4 h-4 text-green-600"
                    checked={
                      selectedPayment === "Online" &&
                      selectedGateway === "AadiPay"
                    }
                    readOnly
                  />

                  <span className="text-lg text-gray-700">
                    Pay with UPI
                  </span>
                </label>
              </div>
            </section>

            {/* <section className="mt-4">
              <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                <label
                  className={`flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer ${selectedGateway === "NeoPayments" ? "border-green-600" : ""
                    }`}
                  onClick={() => {
                    setSelectedPayment("Online");
                    setSelectedGateway("NeoPayments");
                    handleGift();
                  }}
                >
                  <input
                    type="radio"
                    name="payment"
                    className="w-4 h-4 text-green-600 focus:ring-green-500"
                    checked={selectedPayment === "Online" && selectedGateway === "NeoPayments"}
                    readOnly
                  />
                  <span className="text-lg text-gray-700">
                    Pay with NeoPayments (UPI / QR Code)
                  </span>
                </label>
              </div>
            </section> */}

            {/* ================================COD ------------------------------------------------- */}
            {ispayamentMode?.includes("COD") &&
              <section className="mt-4">
                <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                  <label
                    className="flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer"
                    onClick={() => {
                      setSelectedPayment("COD");
                      setSelectedGateway(null);
                    }}
                  >
                    <input
                      type="radio"
                      name="payment"
                      className="w-4 h-4 text-green-600 focus:ring-green-500"
                      checked={selectedPayment === "COD"}
                      readOnly
                    />
                    <span className="text-lg text-gray-700">
                      Cash On Delivery
                    </span>
                  </label>
                </div>
                {selectedPayment === "COD" &&
                  <>
                    <div className="sm:flex  mt-2 text-sm font-bold border-gray-200 justify-center sm:justify-between">
                      <div>
                        <span>COD Charge :- </span>
                        <span>₹100</span>
                      </div>
                      <span className="text-black ">Updated Order Price :- <span className="text-blue-500">{(ViewCart?.finalPrice + 100).toFixed(2)}</span></span>
                    </div>
                    <span className="text-sm text-black font-bold">Avoid ₹100 COD Charges. Paying Online</span>
                  </>
                }
              </section>
            }

            {/* ===============================------------------------------------------------- */}

            <section className="mt-4 mb-2">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input type="checkbox" className="h-4 w-4 text-green-600" />
                <span className="text-sm">
                  I agree to the{" "}
                  <a href="/terms-of-service" className="text-blue-600 underline">
                    Terms and Conditions
                  </a>
                </span>
              </label>
            </section>
          </div>


          <button className=" mt-4 w-full py-3 text-xl bg-orange-400 text-white rounded-lg hover:bg-orange-700 transition duration-300"
            type="button"
            onClick={() => {
              const hasFreeGift = ViewCart?.cart?.some(
                (item) => item?.isFreeGift === true
              );

              if (selectedPayment === "COD") {
                if (hasFreeGift) {
                  setModal(true);
                } else {
                  handleCheckout();
                }
                return;
              }

              if (selectedPayment === "Online") {
                if (selectedGateway === "DhanKubera") {
                  _handleDhanKubera();
                  return;
                }

                if (selectedGateway === "AadiPay") {
                  _handleUPIAadiPay();
                  return;
                }

                // if (selectedGateway === "NeoPayments") {
                //   _handleNeoPayment();
                //   return;
                // }

                toast.error("Please select a payment gateway.");
                return;
              }

              toast.info("Please select payment method.");
            }}
          >

            Confirm Order
          </button>

        </div>
      </div >

      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 text-center">
            <p className="text-gray-700 text-lg mb-6">
              Remove Free Gift to Continue With COD
            </p>

            <div className="flex justify-between gap-4">
              <button
                onClick={handleCloseModal}
                className="w-1/2 bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded-md"
              >
                Cancel
              </button>

              <button
                onClick={handleRemoveGift}
                className="w-1/2 bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-md"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      )}

      {loading && <LoaderPage />}
      <Footer />

      {showUPIModal && upiPaymentData && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
          <div className="relative w-full max-w-md rounded-2xl bg-white p-6 text-center shadow-2xl border border-gray-100">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3 mb-4">
              <div className="text-left">
                <h2 className="text-xl font-bold text-gray-800">Pay with UPI QR</h2>
                <p className="text-xs text-gray-500">Scan & pay using any UPI app</p>
              </div>
              <div className="text-right">
                <span className="text-xs text-gray-500 block">Total Amount</span>
                <span className="text-lg font-bold text-green-600">
                  ₹{Number(upiPaymentData.amount).toFixed(2)}
                </span>
              </div>
            </div>

            {/* Countdown Timer */}
            <div
              className={`mb-4 flex items-center justify-between rounded-xl p-3 ${upiTimer <= 30
                ? "bg-red-50 text-red-700 border border-red-200"
                : upiTimer <= 60
                  ? "bg-amber-50 text-amber-700 border border-amber-200"
                  : "bg-blue-50 text-blue-700 border border-blue-200"
                }`}
            >
              <div className="flex items-center space-x-2">
                <span className="text-lg">⏳</span>
                <span className="text-sm font-medium">Session Expires In:</span>
              </div>
              <span className="text-lg font-extrabold tracking-wider font-mono">
                {formatTimer(upiTimer)}
              </span>
            </div>

            {/* QR Code Container */}
            <div className="mb-4 flex flex-col items-center justify-center rounded-xl bg-gray-50 p-4 border border-gray-200">
              <div className="rounded-lg bg-white p-3 shadow-md">
                <QRCode value={upiPaymentData.qrString} size={200} />
              </div>
              <div className="mt-3 flex items-center justify-center space-x-2 text-xs text-gray-600 font-medium">
                <span>GPay</span>
                <span>•</span>
                <span>PhonePe</span>
                <span>•</span>
                <span>Paytm</span>
                <span>•</span>
                <span>BHIM</span>
              </div>
            </div>

            {/* Verifying Loader / Status Indicator */}
            {isVerifyingPayment && (
              <div className="mb-4 flex items-center justify-center space-x-2 rounded-lg bg-yellow-50 p-3 text-yellow-800 border border-yellow-200 animate-pulse">
                <svg
                  className="h-5 w-5 animate-spin text-yellow-600"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
                <span className="text-sm font-semibold">
                  {upiStatusText || "Verifying payment with bank..."}
                </span>
              </div>
            )}

            {/* Mobile UPI Intent Button (if on mobile with upilink) */}
            {upiPaymentData.upilink && (
              <a
                href={upiPaymentData.upilink}
                className="mb-3 block w-full rounded-lg bg-emerald-600 py-2.5 text-center text-sm font-semibold text-white shadow hover:bg-emerald-700 transition"
              >
                📱 Pay via UPI App (GPay / PhonePe / Paytm)
              </a>
            )}

            {/* Action Buttons: Payment Success / Check Status & Cancel */}
            <div className="flex flex-col sm:flex-row gap-2 mt-2">
              <button
                type="button"
                onClick={handleManualStatusCheck}
                disabled={isVerifyingPayment}
                className={`w-full sm:w-1/2 py-2.5 px-4 rounded-lg font-semibold text-white shadow transition flex items-center justify-center space-x-1 ${isVerifyingPayment
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-green-600 hover:bg-green-700"
                  }`}
              >
                {isVerifyingPayment ? (
                  <span>Checking...</span>
                ) : (
                  <>
                    <span>✓</span>
                    <span>Payment Done</span>
                  </>
                )}
              </button>

              <button
                type="button"
                onClick={handleCancelUPI}
                disabled={isVerifyingPayment}
                className="w-full sm:w-1/2 py-2.5 px-4 rounded-lg font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 border border-gray-300 transition"
              >
                Cancel Payment
              </button>
            </div>

            <p className="mt-3 text-xs text-gray-400">
              Order ID: <span className="font-mono">{upiPaymentData.orderId}</span>
            </p>
          </div>
        </div>
      )}
      <NeoPaymentModal
        isOpen={showNeoModal}
        onClose={() => {
          setShowNeoModal(false);
          navigate("/");
        }}
        paymentData={neoPaymentData}
        guestEmail={guestDetails.email}
        onSuccess={(orderId) => {
          setShowNeoModal(false);
          navigate(`/paymentResultPage?status=SUCCESS&orderId=${orderId}`);
        }}
        onFailure={(orderId) => {
          setShowNeoModal(false);
          navigate(`/paymentResultPage?status=FAILED&orderId=${orderId}`);
        }}
      />
    </div >
  );
};

export default Checkout;